import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from './logo';

class AppHeader extends Component {
  state = {
    isMenuOpen: false,
    isModalOpen: false
  }

  /**
   * Handle the click on the logo for display the info.
   */
  openInfo = () => {
    this.setState({
      isMenuOpen: false,
      isModalOpen: true
    });
  }

  /**
   * Close the modal with the logo info.
   */
  closeModal = () => {
    this.setState({
      isModalOpen: false
    });
  }

  /**
   * Handle the event when user display the navigation menu on mobile devices.
   *
   * @param {*} event
   */
  handleToggle = (e) => {
    if (this.state.isModalOpen) {
      this.closeModal();
    }

    this.setState({
      isMenuOpen: !this.state.isMenuOpen
    });
  }

  handleLinkClick = (e) => {
    this.handleToggle();
    this.closeModal();
  }

  /**
   * Render the component view.
   */
  render() {
    const { color, logo, company } = this.props;

    // Append class to display the menu.
    let navbarClass = 'app-header__navbar';

    if (this.state.isMenuOpen) {
      navbarClass += ' app-header__navbar--open';
    }

    // Custom styles for client.
    let menuItemStyles = {
      borderBottomColor: color
    }

    return (
      <header className="app-header">
        <div className="app-header__content">
          <Logo 
            src={logo} 
            addressApptNum={company.addressApptNum}
            addressCity={company.addressCity}
            addressState={company.addressState}
            addressZip={company.addressZip}
            phoneNumber={company.phoneNumber}
            website={company.website}
            isModalOpen={this.state.isModalOpen}
            onOpenInfo={this.openInfo}
            onClose={this.closeModal} />

          {/**
            ** Toggle for display navbar on mobile devices
            **/}
          <div className={ navbarClass }>
            <div className="app-header__navbar-toggle" onClick={ this.handleToggle }>
              <span className="app-header__toggle-icon"></span>
              <span className="app-header__toggle-icon"></span>
              <span className="app-header__toggle-icon"></span>
            </div>

            {/**
              ** Navitation menu
              **/}
            <nav>
              <ul className="app-header__navbar-items">
                <li>
                  <NavLink 
                    to="/home" 
                    className="app-header__navbar-item" 
                    activeClassName="app-header__navbar-item--active" 
                    activeStyle={menuItemStyles}
                    onClick={this.handleLinkClick}>
                    <i className="fas fa-home"></i> Home
                  </NavLink>
                </li>

                <li>
                  <NavLink 
                    to="/schedule-payment" 
                    className="app-header__navbar-item" 
                    activeClassName="app-header__navbar-item--active" 
                    activeStyle={menuItemStyles}
                    onClick={this.handleLinkClick}>
                    <i className="fas fa-calendar"></i> Schedule
                  </NavLink>
                </li>

                <li>
                  <NavLink 
                    to="/receipts" 
                    className="app-header__navbar-item" 
                    activeClassName="app-header__navbar-item--active" 
                    activeStyle={menuItemStyles}
                    onClick={this.handleLinkClick}>
                    <i className="fas fa-receipt"></i> Receipts
                  </NavLink>
                </li>

                <li>
                  <NavLink 
                    to="/settings" 
                    className="app-header__navbar-item" 
                    activeClassName="app-header__navbar-item--active" 
                    activeStyle={menuItemStyles}
                    onClick={this.handleLinkClick}>
                    <i className="fas fa-cog"></i> Settings
                  </NavLink>
                </li>
              </ul>
            </nav>

            {/**
              ** Logout button
              **/}
            <div className="app-header__navbar-logout">
              <span className="app-header__navbar-item" onClick={this.props.onLogout}>
                <i className="fas fa-power-off"></i> Logout
              </span>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/application/app-header.js